import default_logo from '~/themes/default/assets/logo.png';
import dark_logo from '../themes/default/assets/logo_dark.png';
import pave_logo from '~/themes/default/assets/pave_logo_white_rvb.png';

import pave_logo_dark from '~/themes/default/assets/logo_pave_black.png';

import { pave_default_gradient } from './config';

export const handleUserCustomTheme = (theme) => {
  if (!theme || Object.values(theme).every((item) => !item))
    return {
      logo_primary: pave_logo_dark,
      logo_secondary: pave_logo,
      backgroundColor: pave_default_gradient,
      textColor: null,
      ...theme,
    };
  const { bg_color, bg_text_color, logo, logo_light, logo_light_primary } =
    theme;
  if (!logo_light_primary)
    return {
      logo_primary: logo,
      logo_secondary: logo_light,
      backgroundColor: pave_default_gradient,
      textColor: null,
      ...theme,
    };
  if (logo_light_primary)
    return {
      logo_primary: logo_light,
      logo_secondary: logo_light,
      backgroundColor: bg_color,
      textColor: bg_text_color,
      ...theme,
    };
};
